import { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '@/shared/hooks';

import { setOfflineStatus } from '../model/transcriptorSlice';
import { selectIsRecording } from '../model/transcriptorSlice.selectors';

export const useNetworkStatus = () => {
  const dispatch = useAppDispatch();
  const isRecording = useAppSelector(selectIsRecording);

  useEffect(() => {
    if (!isRecording) {
      return;
    }

    const handleOffline = () => {
      dispatch(setOfflineStatus(true));
    };

    const handleOnline = () => {
      dispatch(setOfflineStatus(false));
    };

    // Set initial status
    if (!navigator.onLine) {
      handleOffline();
    }

    window.addEventListener('offline', handleOffline);
    window.addEventListener('online', handleOnline);

    return () => {
      window.removeEventListener('offline', handleOffline);
      window.removeEventListener('online', handleOnline);
      dispatch(setOfflineStatus(false));
    };
  }, [isRecording]);
};
